module.exports = {
  "pageView": {
    "name": "Pageview",
    "class": "view",
    "properties": {
      "view": "string",
      "language": "string"
    },
    "namespace": "websitegrader"
  },
  "experimentExposure": {
    "name": "Experiment Exposure",
    "class": "exposure",
    "properties": {
      "treatmentKey": "string",
      "websiteUrl": "string",
      "key": "string",
      "value": "string"
    },
    "namespace": "websitegrader"
  },
  "genericAction": {
    "name": "Action",
    "class": "interaction",
    "properties": {
      "type": "string",
      "website": {
        "type": "string",
        "isOptional": true
      }
    },
    "namespace": "websitegrader"
  },
  "trialBannerClick": {
    "name": "Action",
    "class": "interaction",
    "properties": {
      "type": "string",
      "websiteUrl": "string",
      "source": "string"
    },
    "namespace": "websitegrader"
  }
};


//////////////////
// WEBPACK FOOTER
// ./events.yaml
// module id = 243
// module chunks = 0